import script from "./AddGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./AddGroup.vue?vue&type=script&setup=true&lang=js"

import "./AddGroup.vue?vue&type=style&index=0&id=c3195676&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c3195676"]])

export default __exports__